module.exports = __webpack_public_path__ + "img/contingent-image5.e13bdd53.jpg";